module.exports = __webpack_public_path__ + "static/media/oderylogo.19ce229f.png";